import { render, staticRenderFns } from "./AgentRemove.vue?vue&type=template&id=0f10e36a&scoped=true&"
import script from "./AgentRemove.vue?vue&type=script&lang=js&"
export * from "./AgentRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f10e36a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f10e36a')) {
      api.createRecord('0f10e36a', component.options)
    } else {
      api.reload('0f10e36a', component.options)
    }
    module.hot.accept("./AgentRemove.vue?vue&type=template&id=0f10e36a&scoped=true&", function () {
      api.rerender('0f10e36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Agent/AgentRemove.vue"
export default component.exports